import { isEmpty } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import localStore from 'store';

import {
  Tab, Select, Dropdown,
} from 'semantic-ui-react';
import './preferencesStyle.css';

import { v1 as uuidv1 } from 'uuid';
import Rule from './Rule';
import InnerRuleSet from './InnerRuleSet';

import preferenceZIndex from '../../../utilities/preferenceUtil';

const innerRuleSetStyle = {
  width: '100%',
  marginBottom: '55px',
};

function swapHandle(arr, idx1, idx2) {
  const newArr = arr;
  const temp = newArr[idx1];
  newArr[idx1] = newArr[idx2];
  newArr[idx2] = temp;
}

function findOuterRules(ruleId, ruleList) {
  return ruleList.filter(item => item.uid === ruleId).map(item => item.uid);
}

class RuleSet extends Component {
  onSelectDefaultRuleType = (e, data) => {
    const { refId, parentRender } = this.props;

    const preference = localStore.get('preference');
    const { ruleSetList } = preference;
    const ruleSet = ruleSetList.find(rs => rs.uid === refId);

    ruleSet.defaultPreferenceRuleType = data.value;
    localStore.set('preference', preference);
    parentRender();
  };

  selectActionHandler = (e, action) => {
    e.preventDefault();

    const { refId, id, parentRender } = this.props;

    const preference = localStore.get('preference');
    const { ruleSetList, ruleList, innerRuleSetList } = preference;
    const ruleSet = ruleSetList.find(rs => rs.uid === refId);

    switch (action.value) {
      case 'Add Rule': {
        const newRule = {
          uid: uuidv1(),
          ruleType: '',
          facts: [],
          operatorType: '',
          include: false,
        };

        ruleList.push(newRule);
        ruleSet.items.push(newRule.uid);

        localStore.set('preference', preference);
        parentRender();
        break;
      }
      case 'Add Inner Rule': {
        const newInnerRule = {
          uid: uuidv1(),
          ruleType: 'OR',
          items: [],
        };

        innerRuleSetList.push(newInnerRule);
        ruleSet.items.push(newInnerRule.uid);

        localStore.set('preference', preference);
        parentRender();
        break;
      }
      case 'Move Up':
        if (id > 0) {
          swapHandle(ruleSetList, id, id - 1);
          localStore.set('preference', preference);
          parentRender();
        }
        break;
      case 'Move Down':
        if (id < ruleSetList.length - 1) {
          swapHandle(ruleSetList, id, id + 1);
          localStore.set('preference', preference);
          parentRender();
        }
        break;
      case 'Delete RuleSet': {
        const currRuleSet = ruleSetList.find(rs => rs.uid === refId);

        preference.ruleSetList = ruleSetList.filter(
          rs => rs.uid !== refId
        );
        const allCurrentRules = this.findAllCurrentRules(
          currRuleSet,
          ruleList,
          innerRuleSetList
        );
        if (currRuleSet.uid.includes('rs') || currRuleSet.items.length > 0) {
          preference.ruleList = ruleList.filter(
            r => !r.uid.startsWith([currRuleSet.uid])
          );
          preference.innerRuleSetList = innerRuleSetList.filter(
            ir => !ir.uid.startsWith([currRuleSet.uid])
          );
        }

        if (currRuleSet.items.length > 0) {
          preference.ruleList = ruleList.filter(
            item => !allCurrentRules.includes(item.uid)
          );
          preference.innerRuleSetList = innerRuleSetList.filter(
            item => !currRuleSet.items.some(curr => curr.includes(item.uid))
          );
        }

        localStore.set('preference', preference);
        parentRender();
        break;
      }
      default:
        break;
    }
  };

  findAllCurrentRules(currRulesSet, ruleList, innerRuleSetList) {
    let outerRules = [];
    let innerRules = [];
    currRulesSet.items.forEach(element => {
      const rl = findOuterRules(element, ruleList);
      if (rl.length === 0) {
        const inr = this.findInnerRules(element, ruleList, innerRuleSetList);
        innerRules = [...innerRules, ...inr];
      } else {
        outerRules = [...outerRules, ...rl];
      }
    });

    return [...innerRules, ...outerRules];
  }

  findInnerRules(ruleId, ruleList, innerRuleSet) {
    let results = [];
    innerRuleSet.forEach(irs => {
      let rl = findOuterRules(ruleId, ruleList);
      if (irs.uid === ruleId && rl.length > 0) {
        results = [...results, ruleId];
        return;
      }
      if (irs.uid === ruleId && irs.items.length > 0 && rl.length === 0) {
        irs.items.forEach(element => {
          rl = findOuterRules(element, ruleList);
          const orl = rl;
          if (orl.length > 0) {
            results = [...results, ...orl];
            return;
          }
          const nested = this.findInnerRules(element, ruleList, innerRuleSet);
          results = [...results, ...nested];
        });
      }
    });
    return results;
  }

  render() {
    const {
      refId, id, isSubmitting,
    } = this.props;
    const { defaultPreferencesRules } = localStore.get('preferenceDiscover') || {};

    const preference = localStore.get('preference') || {};
    const { ruleSetList, ruleList, innerRuleSetList } = preference;
    const ruleSet = ruleSetList ? ruleSetList.find(rs => rs.uid === refId) : {};

    const ruleSetItems = isEmpty(ruleSet) ? [] : ruleSet.items;

    const items = isEmpty(ruleSetItems)
      ? []
      : ruleSetItems.map((item, idx) => {
        const ruleItems = ruleList.filter(rule => rule.uid === item);
        if (!isEmpty(ruleItems)) {
          return (
            <Rule
              key={item}
              refId={item}
              parentId={refId}
              parentRender={() => {
                this.setState({});
              }}
              first={idx === 0}
              last={idx === ruleSetItems.length - 1}
              isSubmitting={isSubmitting}
            />
          );
        }

        const innerRuleSetItems = innerRuleSetList.filter(
          innerRule => innerRule.uid === item
        );
        if (!isEmpty(innerRuleSetItems)) {
          return (
            <InnerRuleSet
              key={item}
              refId={item}
              ruleSetGroupIndex={`${id + 1}.`}
              innerRuleSetGroupIndex={idx + 1}
              deep={1}
              parentId={refId}
              parentRender={() => {
                this.setState({});
              }}
              first={idx === 0}
              last={idx === ruleSetItems.length - 1}
              isSubmitting={isSubmitting}
            />
          );
        }
        return null;
      });

    const RULE_ACTIONS = [
      { key: 1, text: 'Add Rule', value: 'Add Rule' },
      { key: 2, text: 'Add Inner Rule', value: 'Add Inner Rule' },
      {
        key: 3, text: 'Move Up', value: 'Move Up', disabled: id === 0,
      },
      {
        key: 4,
        text: 'Move Down',
        value: 'Move Down',
        disabled: !ruleSetList || id === ruleSetList.length - 1,
      },
      { key: 'Delete RuleSet', text: 'Delete', value: 'Delete RuleSet' },
    ];

    const panes = [
      {
        menuItem: `RuleSet ${id + 1}`,
        render: () => (
          <Tab.Pane>
            {' '}
            <section className='ruleSet'>
              <div
                className='ruleSetHeaderAction'
                style={{ zIndex: `${100000 - preferenceZIndex(refId)}` }}
              >
                <span />
                <span>
                  <Dropdown
                    style={{ width: '200px' }}
                    fluid
                    selection
                    text='Actions'
                    options={RULE_ACTIONS}
                    selectOnBlur={false}
                    value={null}
                    onChange={this.selectActionHandler}
                  />
                </span>
              </div>

              <div>{isEmpty(items) ? '' : items}</div>

              <div className='defaultPreferencesRuleType'>
                <span className='mr-5px'>
                  Select an additional default preference
                </span>
                <Select
                  placeholder='Select default preference'
                  options={defaultPreferencesRules}
                  closeOnBlur
                  value={
                    isEmpty(ruleSet) ? '' : ruleSet.defaultPreferenceRuleType
                  }
                  onChange={this.onSelectDefaultRuleType}
                  style={{
                    border:
                      isEmpty(ruleSet.defaultPreferenceRuleType)
                      && isSubmitting
                        ? '1px solid red'
                        : '',
                    zIndex: `${100000 - preferenceZIndex(refId) - 99}`,
                  }}
                />
                {isEmpty(ruleSet.defaultPreferenceRuleType)
                  && isSubmitting && (
                    <div style={{ color: 'red', paddingRight: '8%' }}>
                      This field is required
                    </div>
                )}
              </div>
            </section>
          </Tab.Pane>
        ),
      },
    ];

    return <Tab panes={panes} style={innerRuleSetStyle} />;
  }
}

RuleSet.propTypes = {
  refId: PropTypes.string.isRequired,
  parentRender: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  isSubmitting: PropTypes.bool,
};

RuleSet.defaultProps = {
  isSubmitting: false,
};

export default RuleSet;
